module.exports = __webpack_public_path__ + "img/iso14001.0071902a.png";